import { render } from "./CredentialsPage.vue?vue&type=template&id=21d9b548"
import script from "./CredentialsPage.vue?vue&type=script&lang=js"
export * from "./CredentialsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__